'use client';

import { BigNum, QUOTE_PRECISION_EXP } from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { useMemo } from 'react';
import useMarkPrice from './useMarkPrice';

const useCollateralPrice = (spotMarketIndex: number) => {
	const marketId = useMemo(() => {
		return MarketId.createSpotMarket(spotMarketIndex);
	}, [spotMarketIndex]);

	const markPrice = useMarkPrice(marketId);

	if (spotMarketIndex === 0) {
		// USDC
		return BigNum.from(1).shift(QUOTE_PRECISION_EXP);
	}

	return markPrice.shift(QUOTE_PRECISION_EXP);
};

export default useCollateralPrice;
